import { useUISettings } from './useUISettings';
import { getLanguageDirection } from '../components/widgets/conversation/advancedFilterItems/languages';
import { computed } from 'vue';

export function useRTLView() {
  const { updateUISettings, uiSettings } = useUISettings();
  const isRTLView = computed(() => uiSettings.value?.rtl_view || false);

  function updateRTLDirectionView(locale) {
    const isRTLSupported = getLanguageDirection(locale);
    if (isRTLSupported !== isRTLView.value) {
      updateUISettings({
        rtl_view: isRTLSupported,
      });
    }
  }

  const isRTL = isRTLView;

  return { isRTLView, updateRTLDirectionView, isRTL };
}
